import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { fetchReports } from "../../../api/endpoint";
import Loader from "../../../components/loader";
import { BsInfoCircle } from "react-icons/bs";
import Table from "../../../components/table";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const User = () => {
  const navigate = useNavigate();
  const { auth } = useSelector((state) => state.login);

  const [tableData, setTableData] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const headings = [
    { name: "S No.", fieldName: "sNo", isSortable: false, sortKey: "none" },
    { name: "Reporter", fieldName: "reporter", isSortable: false, sortKey: "none" },
    { name: "Reason", fieldName: "reason", isSortable: false, sortKey: "none" },
    { name: "Reported user", fieldName: "reportedUser", isSortable: false, sortKey: "none" },
    { name: "Status", fieldName: "status", isSortable: false, sortKey: "none" },
    { name: "Actions", fieldName: "actions", isSortable: false, sortKey: "none" },
  ];

  useEffect(() => {
    if (auth) fetchUserReports();
  }, [auth, statusFilter]);

  const getActionButtons = (reportId) => (
    <div className="d-flex align-items-center gap-2">
      <button
        className="btn p-0 mb-1"
        onClick={() => handleOpenDetails(reportId)}
        style={{ cursor: "pointer" }}
        title="View Details"
      >
        <BsInfoCircle size={20} />
      </button>
    </div>
  );

  const handleOpenDetails = (reportId) => {
    navigate("/user-report-details", {
      state: { reportId },
    });
  };

  const fetchUserReports = async () => {
    try {
      setLoading(true);
      const params = {
        type: "USER",
        ...(statusFilter !== "ALL" && { status: statusFilter }),
      };

      const response = await axios.get(fetchReports, {
        headers: { Authorization: `Bearer ${auth}` },
        params,
      });

      const data = response?.data?.content?.map((r, i) => ({
        sNo: i + 1,
        reporter: r?.reporterName,
        reason: r?.reason,
        reportedUser: r?.reportedUserName,
        status: r?.status,
        actions: getActionButtons(r?.reportId),
      }));

      setTableData(data);
      setCurrentPage(response?.data?.currentPage);
      setPageSize(response?.data?.pageSize);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="d-flex gap-2 align-items-center justify-content-end">
        <label>Status:</label>
        <select
          className="form-select form-select-sm w-auto"
          role="button"
          onChange={(e) => setStatusFilter(e.target.value)}
          value={statusFilter}
        >
          <option value="ALL">All</option>
          <option value="REVIEWING">Reviewing</option>
          <option value="ACTION_TAKEN">Action taken</option>
          <option value="REJECTED">Rejected</option>
          <option value="CLOSED">Closed</option>
        </select>
      </div>

      <Table
        headings={headings}
        data={tableData}
        currentPage={currentPage}
        totalPages={totalPages}
        enablePagination={tableData?.length > pageSize}
        card={true}
      />

      {loading && <Loader />}
    </div>
  );
};

export default User;
